// Import package components
import { useContext } from "react";
import UIkit from "uikit";

// Import base components
import { AppContexts } from "../../providers";

// Import common components
import Dialog from "../common/Dialog";

const TeamUserGroup = () => {
  const inboxCtx = useContext(AppContexts.InboxContext);

  const handleDelete = () => {
    inboxCtx.deleteRecipient(inboxCtx.deletedRecipient);
    UIkit.modal("#team-delete").hide();
  };

  const recipientName = () => {
    if (!inboxCtx.deletedRecipient) {
      return "";
    }

    console.log(inboxCtx);

    return `${inboxCtx.deletedRecipient.first_name} ${inboxCtx.deletedRecipient.last_name}`;
  };

  return (
    <>
      <Dialog id="team-delete">
        <div className="uk-modal-dialog uk-modal-body">
          <button
            className="uk-modal-close-default"
            type="button"
            uk-close="true"
          ></button>
          <h2 className="uk-modal-title">Delete Team Member</h2>
          <p>
            Are you sure you want to delete <b>{recipientName()}</b>?
          </p>
          <p className="uk-text-right">
            <button
              className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
              type="button"
            >
              Cancel
            </button>
            <button
              className="uk-button hms-btn hms-gray-btn"
              type="button"
              onClick={handleDelete}
            >
              Delete
            </button>
          </p>
        </div>
      </Dialog>
    </>
  );
};

export default TeamUserGroup;
